import React from 'react';
import { Link } from 'react-router-dom';
import Animated from 'components/generals/AnimatedComponent';
import logo_ptg from 'assets/images/logos/ptg-blue.png';
import logo_hsc from 'assets/images/logos/harbor.webp';
import logo_ptyss from 'assets/images/logos/PTYSS-logo-blue.png';
export default function CompaniesBlock() {
    return (
        <>
            <section className="nv__main__home__container">
                <section className="nv__main__home__companies">
                    <div className="nv__main__home__block">
                        <Animated animation={'animate__fadeInUp animate__delay-1s'}>
                            <Link to="/ptg">
                                <div className="nv__main__home__block__content transition">
                                    <div className="nv__main__home__block__image transition">
                                        <div className="nv__main__home__block__image__item">
                                            <img src={logo_ptg} alt="PTG" />
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </Animated>
                    </div>
                    <div className="nv__main__home__block">
                        <Animated animation={'animate__fadeInUp animate__delay-2s'}>
                            <Link to="/harbour">
                                <div className="nv__main__home__block__content transition">
                                    <div className="nv__main__home__block__image transition">
                                        <div className="nv__main__home__block__image__item">
                                            <img src={logo_hsc} alt="HSC" className="image_small" />
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </Animated>
                    </div>

                    <div className="nv__main__home__block">
                        <Animated animation={'animate__fadeInUp animate__delay-3s'}>
                            <Link to="/ptyss">
                                <div className="nv__main__home__block__content transition">
                                    <div className="nv__main__home__block__image transition">
                                        <div className="nv__main__home__block__image__item">
                                            <img
                                                src={logo_ptyss}
                                                alt="ptyss"
                                                className="image_medium"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </Animated>
                    </div>
                </section>
            </section>
        </>
    );
}
